module.exports = __webpack_public_path__ + "img/spilka.d5976505.png";